#@import Booking.Models.LocalBookingSettings
#@import Booking.Models.Base
#@export Booking.Models.Option

class Booking.Models.Option extends Booking.Models.Base

  idAttribute: 'uuid'

  constructor: (attributes, options) ->
    options = _.extend({}, options, parse: true)
    Booking.Models.Base.call(this, attributes, options)

  parse: (raw) ->
    if raw?.localBookingSettings
      _.extend({}, raw, {
        localBookingSettings: new Booking.Models.LocalBookingSettings(raw.localBookingSettings)
      })
    else
      raw

  getTitle: ->
    @get('title')

  getShowDiscount: ->
    @get('showDiscount')

  getShowQuantity: ->
    @get('showQuantity')

  getRedemptionLocation: ->
    @get('redemptionLocations')[0] # Only supports single redemption location merchants

  getLocationName: ->
    @getRedemptionLocation()?.name

  getPrice: ->
    @get('price')?.amount

  getFormattedPrice: ->
    @get('price').formattedAmount

  getFormattedValue: ->
    @get('value').formattedAmount

  isSoldOut: ->
    @get('isSoldOut')

  getDiscount: ->
    @get('discount')

  getLocalBookingSettings: ->
    @get('localBookingSettings')

  getSchedulerOptions: ->
    @get('schedulerOptions')

  getPricingMetadata: ->
    @get('pricingMetadata')

  getSoldQuantity: ->
    @get('soldQuantity')

  getSoldQuantityMessage: ->
    @get('soldQuantityMessage')

  getEnabledFeatures: ->
    @getSchedulerOptions()?.enabledFeatures || []

  reservesAvailability: ->
    Booking.Models.Option.RESERVED_AVAILABILITY in @getEnabledFeatures()

  getProviderName: ->
    @getSchedulerOptions()?.bookingProviderName

  getAvailability: ->
    @getLocalBookingSettings().getAvailability()

  getAdditionalAttributes: ->
    @getLocalBookingSettings().getAdditionalAttributes()

  isG3: ->
    @reservesAvailability() is true

  isARSE: ->
    not @reservesAvailability() and not @getProviderName()

  getPartySizeSettings: ->
    @getAdditionalAttributes().getPartySize()

  getPhoneSettings: ->
    @getAdditionalAttributes().getPhone()

  getTextNotificationsSettings: ->
    @getAdditionalAttributes().getTextNotifications()

  getQuestionsSettings: ->
    @getAdditionalAttributes().getQuestions()

Booking.Models.Option.RESERVED_AVAILABILITY = 'reservedAvailability'
